var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-button"},[_c('div',{staticClass:"result-button-main"},[_c('ui-button',{staticClass:"result-button-box",nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)],1),_c('div',{staticClass:"result-button-holder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }